import { Alert, AlertIconType, AlertType, CreateAlert } from 'types';
import { v4 as uuid } from 'uuid';
import { create } from 'zustand';
import { devtools } from './helpers';

interface AlertState {
  lastAlert: (Alert & { time: number }) | null;
  alerts: Alert[];
  addAlert: (alert: CreateAlert) => void;
  closeAlert: (id: string) => void;
}

export const useAlerts = create<AlertState>()(
  devtools(
    (set, get) => ({
      lastAlert: null,
      alerts: [],
      addAlert: (alert: CreateAlert) => {
        const lastAlert = get().lastAlert;
        if (
          lastAlert &&
          lastAlert.time >= Date.now() - 1000 &&
          lastAlert.title === alert.title &&
          lastAlert.body === alert.body &&
          lastAlert.icon === alert.icon
        )
          return;

        const addedAlert = {
          ...alert,
          id: alert.id || uuid(),
          type: alert.type || AlertType.simple,
          icon: alert.icon || AlertIconType.success,
          quiet: alert.quiet || false,
          important: alert.important || false,
        };

        set(state => ({
          alerts: [...state.alerts, addedAlert],
          lastAlert: { ...addedAlert, time: Date.now() },
        }));
      },
      closeAlert: (id: string) => set(state => ({ alerts: state.alerts.filter(alert => alert.id !== id) })),
    }),
    { name: 'alerts' },
  ),
);
